<script lang="ts">
    import {
        VpAddIcon,
        VpCalendarIcon,
        VpEditIcon,
        VpMapPinIcon,
        VpRunIcon,
        VpUserIcon,
    } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import { filtersContext } from '$saga/views/Search/store';
    import { FilterType } from '$saga/views/Search/types';

    export let handleSelectedFilter: (filterType: FilterType) => void;

    $: sportCount = $filtersContext.formLabels.theme.length;
    $: destinationCount = $filtersContext.formLabels.destination.length;
    $: isDateSelected =
        $filtersContext.formLabels.startDate != null ||
        $filtersContext.formLabels.months.length > 0;
    $: isPaxSelected =
        $filtersContext.formLabels.nbPax !== '' &&
        $filtersContext.formLabels.nbPax !== '0';

    const buttonClass =
        'flex w-full items-center justify-between p-s hover:bg-container-commercial-neutral';
</script>

<button
    class={buttonClass}
    on:click|preventDefault|stopPropagation={() =>
        handleSelectedFilter(FilterType.SPORT)}
>
    <span
        class={cn(
            'flex items-center gap-xs text-sm',
            sportCount > 0 && 'text-content-brand',
        )}
    >
        <VpRunIcon class="size-xl" />
        {trans('search.bar.sport')}{sportCount > 0 ? ` (${sportCount})` : ''}
    </span>
    <span>
        {#if sportCount > 0}
            <VpEditIcon class="size-m" />
        {:else}
            <VpAddIcon class="size-m" />
        {/if}
    </span>
</button>
<button
    class={buttonClass}
    on:click|preventDefault|stopPropagation={() =>
        handleSelectedFilter(FilterType.DESTINATION)}
>
    <span
        class={cn(
            'flex items-center gap-xs text-sm',
            destinationCount > 0 && 'text-content-brand',
        )}
    >
        <VpMapPinIcon class="size-xl" />
        {trans('search.bar.destination')}{destinationCount > 0
            ? ` (${destinationCount})`
            : ''}
    </span>
    <span>
        {#if destinationCount > 0}
            <VpEditIcon class="size-m" />
        {:else}
            <VpAddIcon class="size-m" />
        {/if}
    </span>
</button>
<button
    class={buttonClass}
    on:click|preventDefault|stopPropagation={() =>
        handleSelectedFilter(FilterType.STARTDATE)}
>
    <span
        class={cn(
            'flex items-center gap-xs whitespace-nowrap text-sm',
            isDateSelected && 'text-content-brand',
        )}
    >
        <VpCalendarIcon class="size-xl" />
        {trans('search.bar.departure_date')}{isDateSelected ? ' (1)' : ''}
    </span>
    <span>
        {#if isDateSelected}
            <VpEditIcon class="size-m" />
        {:else}
            <VpAddIcon class="size-m" />
        {/if}
    </span>
</button>
<button
    class={buttonClass}
    on:click|preventDefault|stopPropagation={() =>
        handleSelectedFilter(FilterType.PAX)}
>
    <span
        class={cn(
            'flex items-center gap-xs text-sm',
            isPaxSelected && 'text-content-brand',
        )}
    >
        <VpUserIcon class="size-xl" />
        {trans('search.bar.travelers')}{isPaxSelected ? ' (1)' : ''}
    </span>
    <span>
        {#if isPaxSelected}
            <VpEditIcon class="size-m" />
        {:else}
            <VpAddIcon class="size-m" />
        {/if}
    </span>
</button>
